import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Moment } from 'moment/moment';
import moment from 'moment';
import { TranslateModule } from '@ngx-translate/core';
import { AssistantTasksService } from '@nimbus-assistant/services/assistant-tasks.service';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { BackgroundTaskFactory } from '@nimbus-library/features/background-task/background-task.factory';
import { SharedUIModule } from '@nimbus-library/features/shared/shared.ui.module';
import { FooterActionsComponent, TaskActionsMode } from '../shared/actions/footer-actions.component';

@Component({
  standalone: true,
  selector: 'app-footer-parked',
  templateUrl: './footer-parked.component.html',
  styleUrls: ['./footer-parked.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, SharedUIModule, FooterActionsComponent],
})
export class FooterParkedComponent implements OnInit {
  public readonly TranslationKeys = TranslationKeys;
  public readonly TaskActionsMode = TaskActionsMode;
  public currentMoment$: Observable<Moment>;

  public readonly parkedCount$ = this.tasksService.parkedTasks$.pipe(map((tasks) => tasks.length));

  public readonly longestElapsedTime$ = this.tasksService.parkedTasks$.pipe(
    map((tasks) => {
      if (!tasks?.length) {
        return null;
      }
      return tasks.reduce((oldest, current) => (moment(current.acceptedAt).isBefore(moment(oldest.acceptedAt)) ? current : oldest))
        .acceptedAt;
    }),
  );

  public constructor(
    private readonly tasksService: AssistantTasksService,
    private readonly backgroundTaskFactory: BackgroundTaskFactory,
  ) {}

  public ngOnInit(): void {
    this.currentMoment$ = this.backgroundTaskFactory.getServerWatches();
  }
}
